<template>
    <div class="favourite-modal-delete">
        <h1>{{ message.textChangeProduct }}</h1>
        <p>{{ message.textDel }}</p>
        <form class="favourite-modal-delete__form" @submit.prevent="deleteItems(checkIds)">
            <!--                <input type="radio" name="name" />-->
            <div class="favourite-modal-delete__form-group">
                <button type="submit" class="def-button">{{ message.btnDel }} </button>
                <span @click="close">{{ message.btnCancel }}</span>
            </div>
        </form>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "favourite-modal-delete",
    props: {
        item: {
            type: [Object, Array],
        },
        groupId: {
            type: String,
        }
    },
    methods: {
        deleteItems(id) {
            const data = { id: id, groupId: this.groupId};

            this.$store.dispatch('favourite/deleteFromFavorite', data );
            this.close()
        },
        close() {
            this.$DefModal.hide();
        }
    },
    computed: {
        checkIds() {
            if ( this.item ) {
                return this.item;
            } else {
                return this.item.offer && this.item.offer.id || this.item.id;
            }
        },
        ...mapState({
            message: ({ favourite }) => favourite?.data?.message,
        })
    }
}
</script>

<style scoped lang="scss">
    .favourite-modal-delete{
        display: flex;
        flex-direction: column;
        &__form{
            display: flex;
            align-items: center;
            justify-content: center;
        }
        &__content{
            margin-top: 17px;
        }
        p{
            margin: 8px 0 24px;
            @include point-md{
                font-size: rem(16);
            }
        }
        svg{
            width: 13px;
            height: 14px;
            fill: #757575;
            cursor: pointer;
        }
        h1{
            font-size: rem(14);
            font-weight: 500;
            letter-spacing: 0.08em;
            text-transform: uppercase;
            @include point-md{
                font-size: rem(18);
            }
        }
        span{
            border-bottom: 0.0625rem dashed #618EAF;
            color: #618EAF;
            cursor: pointer;
            margin-left: 15px;
            font-size: rem(12);
            text-transform: uppercase;
            letter-spacing: 0.1em;
        }
        .def-button{
            transition: 0.2s linear background;
            text-transform: uppercase;

            &:hover{
                background: rgba(97, 142, 175, 0.8);
                transition: 0.2s linear background;
            }
        }
    }
</style>